import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import PropTypes from 'prop-types'
import './DonutChartT2.scss'

export class DonutChartT2 extends React.Component {

  render() {
    const { chartData, noHeader, propertyType, themeColors, donutChartThemeColors } = this.props
    const data = {
      labels: chartData && Object.keys(chartData).sort(),
      datasets: [
        {
          data: chartData && Object.keys(chartData).sort()
          .map(label => chartData[`${label}`]),
          backgroundColor: chartData && Object.keys(chartData).sort()
          .map(label => donutChartThemeColors[label.trim().replace(/ /g, '')
                                                          .toLowerCase()
                                                          .replace('/', ' / ')
                                                          .replace('bedroom', ' Bedroom')
                                                          .replace('bath', ' Bath')]),
          hoverBackgroundColor: chartData && Object.keys(chartData).sort()
          .map(label => donutChartThemeColors[label.trim().replace(/ /g, '')
                                                          .toLowerCase()
                                                          .replace('/', ' / ')
                                                          .replace('bedroom', ' Bedroom')
                                                          .replace('bath', ' Bath')])
        }
      ]
    }
    const headingStyle = {
      // fontFamily: '\'Roboto Condensed\', sans-serif',
      fontFamily: '\'DIN Pro Light\'',
      fontSize: '16px',
      fontWeight: 'bold',
      color: propertyType.toString().includes('S') ? themeColors.subjectSectionHeadingColor : themeColors.comparableSectionHeadingColor,
      padding: 0,
      margin: 0,
      marginTop: '-6px'
    }

    return (
      <div data-testid="donut-chart" className="donutchartT2">
        <div className="chart">
          <div className="donutchartT2">
            {!noHeader && <h2 style={ headingStyle }>UNIT MIX</h2>}
            <Doughnut data={data}
              options={{
                padding: '0px',
                responsive: true,
                maintainAspectRatio: false,
                defaultFontSize: '14px',
                tooltips: {
                  enabled: false
                },
                legend: {
                  display: false
                },
                elements: {
                  arc: {
                    borderWidth: 0
                  }
                },
                cutoutPercentage: 65
              }}
            />
          </div>
          <div className="chartlabel">
            {chartData && Object.keys(chartData).sort()
            .map((unitType, index) => (
              <div key={index} className="donutlabel">
                <div style={{ 'backgroundColor': donutChartThemeColors[unitType.trim().replace(/ /g, '')
                    .toLowerCase()
                    .replace('/', ' / ')
                    .replace('bedroom', ' Bedroom')
                    .replace('bath', ' Bath')] }} className="labelcolor"></div>
                <div>{`${unitType.includes('0 Bedroom') ? 'Studio' : unitType.replace('Bedroom', 'Bed')} - ${chartData[unitType]}%`}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

DonutChartT2.propTypes = {
  chartData: PropTypes.shape({
    '1 Bedroom / 1 Bath': PropTypes.number,
    '2 Bedroom / 1 Bath': PropTypes.number,
    '2 Bedroom / 2 Bath': PropTypes.number,
    '3 Bedroom / 3 Bath': PropTypes.number
  }),
  donutChartThemeColors: PropTypes.object,
  noHeader: PropTypes.bool,
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  themeColors: PropTypes.object
}
export default DonutChartT2
